export default __webpack_public_path__ + "static/fb29b3e94c17b2ec95646d5d1de923c8.jpeg";